import {Arr, Obj, SchemaToType, Str} from '@shared/api/core/api_schema';

const ChampionSummarySchema = Obj({
  name: Str(),
  role: Str(),
  description: Str(),
  ulti: Str(),
  passive: Str(),
  spell1: Str(),
  spell2: Str(),
  spell3: Str(),
});
export type ChampionSummary = SchemaToType<typeof ChampionSummarySchema>;

const AnalysisSchema = Arr(ChampionSummarySchema);
export type Analysis = SchemaToType<typeof AnalysisSchema>;

export const APP_API = {
  '/gpt-team-description': {
    POST: {
      req: Obj({teamBlue: Arr(Str()), teamRed: Arr(Str())}),
      res: AnalysisSchema,
    },
  },
  '/gpt-champion-description': {
    POST: {
      req: Obj({championName: Str()}),
      res: Obj({data: Str()}),
    },
  },
  '/gpt-champion-description-prefetch': {
    POST: {
      req: Obj({championNames: Arr(Str())}),
      res: Obj({}),
    },
  },
  '/gpt-lane-description': {
    POST: {
      req: Obj({teamBlue: Arr(Str()), teamRed: Arr(Str()), lane: Str()}),
      res: Obj({data: Str()}),
    },
  },
  '/gpt-team-meta': {
    POST: {
      req: Obj({model: Str(), teamBlue: Arr(Str()), teamRed: Arr(Str())}),
      res: Obj({data: Str()}),
    },
  },
};
